module.exports = __webpack_public_path__ + "img/icon_map_4_on_111.804e5c8c.png";